import Flickity from 'flickity'
import { parseJSON } from '@/components/helpers/utils'
const defaultOptions = {
  contain: true
}
export class Carousel extends HTMLElement {
  connectedCallback() {
    this.initializeCarousel()
    this.setupMutationObserver()
  }

  initializeCarousel() {
    const computedHeight = this.getBoundingClientRect().height

    if (computedHeight > 0) {
      this.style.minHeight = `${computedHeight}px`
    }

    const options = this.carouselSettings
    options.cellSelector = '&:not(style)'
    const mergedOptions = { ...defaultOptions, ...options }
    if (mergedOptions.wrapAround === true) {
      delete mergedOptions.contain
    }
    if (mergedOptions.autoPlay && mergedOptions.freeScroll === true) {
      mergedOptions.freeScroll = false
    }
    this.flickity = new Flickity(this, mergedOptions)

    this.flickity.on('ready', () => {
      requestAnimationFrame(() => {
        const viewport = this.querySelector('.flickity-viewport')
        if (viewport && viewport.style.height) {
          requestAnimationFrame(() => {
            if (this.style.minHeight) {
              this.style.minHeight = ''
            }
          })
        }
      })
    })
  }

  isFlickityElement(element) {
    if (!element.classList) return false

    return Array.from(element.classList).some((className) => className.startsWith('flickity-'))
  }

  setupMutationObserver() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
    }

    this.mutationObserver = new MutationObserver((mutations) => {
      let shouldReinitialize = false

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const hasRelevantChanges =
            Array.from(mutation.addedNodes).some(
              (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'STYLE' && !this.isFlickityElement(node)
            ) ||
            Array.from(mutation.removedNodes).some(
              (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'STYLE' && !this.isFlickityElement(node)
            )

          if (hasRelevantChanges) {
            shouldReinitialize = true
          }
        }
      })

      if (shouldReinitialize) {
        this.reinitializeCarousel()
      }
    })

    this.mutationObserver.observe(this, {
      childList: true,
      subtree: false
    })
  }

  reinitializeCarousel() {
    if (this.flickity) {
      this.flickity.destroy()
      this.flickity = null
    }

    requestAnimationFrame(() => {
      this.initializeCarousel()
    })
  }

  observedAttributes = ['carousel-settings']

  get carouselSettings() {
    const carouselSettings = this.getAttribute('carousel-settings')
    if (!carouselSettings) return {}
    const parsedSettings = parseJSON(carouselSettings)
    if (parsedSettings?.groupCells !== undefined) {
      const value = parsedSettings.groupCells

      if (value === 'true') {
        parsedSettings.groupCells = true
      } else if (value === 'false') {
        parsedSettings.groupCells = false
      } else if (!isNaN(value) && typeof value === 'string') {
        parsedSettings.groupCells = Number(value)
      }
    }
    return parsedSettings
  }

  disconnectedCallback() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
      this.mutationObserver = null
    }

    if (this.flickity) {
      this.flickity.destroy()
      this.flickity = null
    }
  }
}
